export const getCookiesInSession = () => {
  const cookiesInSess = document.cookie ? document.cookie : null;
  const cookiesArray = cookiesInSess ? cookiesInSess.split(" ") : [];
  const findHpy = cookiesArray.length ? cookiesArray.filter((name) => name.includes("hpy_")) : null;
  const options =
    findHpy && findHpy.length
      ? findHpy.map((cookie) => {
          let value;
          value = cookie.includes("true") ? true : false;
          return {
            default_check: value,
            related: {
              id: cookie.substring(0, cookie.indexOf("=")),
            },
          };
        })
      : [];
  return options;
};

export const setCookiesInSession = (cookies) => {
  const expiration = new Date();
  expiration.setFullYear(expiration.getFullYear() + 2).toString();
  const path = "path=/";
  cookies.options.forEach((cookie) => {
    const cookieString = `${cookie.related.id}=${cookie.default_check}; ${path}; expires=${expiration}`;
    document.cookie = cookieString;
  });
};

export const getAcceptedCookiesList = (options) => {
  let list = [];
  const cookiesAccepted = options && options.length ? options.filter((opt) => opt.default_check == true) : [];
  cookiesAccepted.length
    ? cookiesAccepted.map((macro) => {
        if (macro.related.list && macro.related.list.length) {
          macro.related.list.map((el) => list.push(el));
        }
      })
    : null;
  return list;
};
